import type { WildLarkTaskHarness } from "../wildlark/client"
import { sortModelsForPresentation } from "../modelPresentation"
import type { SavedActionSessionLaunch } from "./actionTypes"
import type { ModelPricingMetadata } from "../modelCatalog"

const DEFAULT_MULTI_AGENT_TARGET_LIMIT = 4

export type { AgentTarget as SessionActionTarget } from "../agentTarget"
import type { AgentTarget as SessionActionTarget } from "../agentTarget"
import { agentTargetId } from "../agentTarget"

export type SessionActionTargets = readonly [SessionActionTarget, ...SessionActionTarget[]]

export function sessionActionTargetRange(sessionLaunch: SavedActionSessionLaunch): { minTargets: number; maxTargets: number } {
    if (sessionLaunch.kind === "delegate") return { minTargets: 1, maxTargets: 1 }
    return {
        minTargets: 1,
        maxTargets: sessionLaunch.maxTargets ?? DEFAULT_MULTI_AGENT_TARGET_LIMIT,
    }
}

export function sessionActionTargetId(target: SessionActionTarget): string {
    return agentTargetId(target)
}

export interface SessionActionAgentOption extends SessionActionTarget {
    id: string
    harnessLabel: string
    modelLabel: string
    displayClass?: string
    default: boolean
    legacy: boolean
    nativeProvider?: string
    supportsImages?: boolean
    pricing?: ModelPricingMetadata
    catalogOrder: number
}

export function sessionActionAgentOptions(harnesses: readonly WildLarkTaskHarness[]): SessionActionAgentOption[] {
    const options: SessionActionAgentOption[] = []
    let catalogOrder = 0
    for (const harness of harnesses) {
        if (!harness.installed || !harness.available) continue
        for (const model of harness.models) {
            options.push({
                id: sessionActionTargetId({ harnessId: harness.harnessId, modelId: model.modelId }),
                harnessId: harness.harnessId,
                modelId: model.modelId,
                harnessLabel: harness.label,
                modelLabel: model.label ?? model.modelId,
                ...(model.displayClass ? { displayClass: model.displayClass } : {}),
                default: model.default === true || model.modelId === harness.defaultModel,
                legacy: model.legacy === true,
                ...(model.nativeProvider ? { nativeProvider: model.nativeProvider } : {}),
                ...(model.capabilities?.images ? { supportsImages: true } : {}),
                ...(model.pricing ? { pricing: model.pricing } : {}),
                catalogOrder,
            })
            catalogOrder += 1
        }
    }
    return sortModelsForPresentation(options)
}
